import { Configuration } from '@shared/models/configuration';

// @dynamic
export class NotificationsConfig {

  private static get AlertApi(): string {
    return Configuration.AlertApi;
  }

  static get getDeleteAlertsApi(): string {
    return `${NotificationsConfig.AlertApi}Command/RemoveAlerts`;
  }

  static get getUpdateSubscriptionStateApi(): string {
    return `${NotificationsConfig.AlertApi}Command/UpdateSubscriptionState`;
  }

}
